"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRerender = void 0;
var react_1 = require("react");
var __1 = require("..");
var stateChanger = function (state) { return !state; };
/**
 * Return callback function that re-renders component.
 */
function useRerender() {
    var _a = (0, __1.useSafeState)(false), setState = _a[1];
    return (0, react_1.useCallback)(function () {
        setState(stateChanger);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
exports.useRerender = useRerender;
